import {
    apiRegister
} from '../utils/api'


/**
 * 获取鉴定品类标签
 * @start	int	开始位置 默认0
 * @pageNum	int	获取数量 默认全部标签
 */
export const jiandingGetTabs = apiRegister('jiandingGetTabs', {
    protoId: 1311,
    path: '/xsh/jianding/get/tabs/'
}).send

/**
 * 获取订单列表
 * @status	int	订单状态 1：创建订单2.待付款 3.待鉴定 4鉴定完成 5取消鉴定 6.暂定等待 7.已评价 默认 4
 * @tabid	int	标签id 默认 全部标签
 * @aid	int	鉴定师 uid 默认全部
 * @uid	int	申请鉴定人uid 默认全部
 * @start	int	开始位置 默认0
 * @pageNum	int	每页条数 默认10
 */
export const jiandingGetOrders = apiRegister('jiandingGetOrders', {
    protoId: 1312,
    path: '/xsh/jianding/get/orders/'
}).send

/**
 * 订单详情
 * @id	int	订单id
 */
export const jiandingOrderDetail = apiRegister('jiandingOrderDetail', {
    protoId: 1313,
    path: '/xsh/jianding/order/detail/'
}).send

/**
 * 鉴定师列表
 * @orderid	订单id	可选
 */
export const jiandingGetAppraisers = apiRegister('jiandingGetAppraisers', {
    protoId: 1314,
    path: '/xsh/jianding/get/appraisers/'
}).send

/**
 * 取消鉴定
 * @id	int	订单id
 * @reply	string	取消原因
 */
export const jiandingOrderCancel = apiRegister('jiandingOrderCancel', {
    protoId: 1315,
    path: '/xsh/jianding/order/cancel/'
}).send

/**
 * 暂停鉴定
 * @id	int	订单id
 * @vNums	string	问题视频序号 逗号隔开
 * @pNums	string	问题图片序号 逗号隔开
 * @reason	string	暂停原因
 */
export const jiandingOrderStop = apiRegister('jiandingOrderStop', {
    protoId: 1316,
    path: '/xsh/jianding/order/stop/'
}).send

/**
 * 选择鉴定师发起申请鉴定
 * @orderId	int	订单id
 * @aid	int	选定的鉴定师
 * @type	int	鉴定类型 鉴定类型 1 普通 2快速
 */
export const jiandingStepChoose = apiRegister('jiandingStepChoose', {
    protoId: 1317,
    path: '/xsh/jianding/step/choose/'
}).send

/**
 * 申请鉴定人 创建鉴定订单
 * @id	int	订单id 有则修改 0添加 默认0
 * @des	string	申请人留言
 * @pirtures	array	上传图片
 * @files	array	上传视频
 * @tabid	int	所属标签
 * @myaid	int	我想要的鉴定师uid
 */
export const jiandingStepCreate = apiRegister('jiandingStepCreate', {
    protoId: 1318,
    path: '/xsh/jianding/step/create/'
}).send

/**
 * 编辑鉴定内容 和 鉴定
 * @do	int	是否鉴定完成 0保存 1完成鉴定 默认1
 * @doorderId	int	订单id
 * @dodefinition	string	鉴定物品名称
 * @doperiods	int	年代
 * @dotrend	int	价格趋势
 * @doreply	string	鉴定内容
 */
export const jiandingStepDo = apiRegister('jiandingStepDo', {
    protoId: 1319,
    path: '/xsh/jianding/step/do/'
}).send

/**
 * 发起评价
 * @orderId	int	订单id
 * @start	int	评星 默认5
 * @service	int	服务评价 默认1
 * @speed	int	速度评价 默认1
 */
export const jiandingEvaluate = apiRegister('jiandingEvaluate', {
    protoId: 1320,
    path: '/xsh/jianding/step/appraise/'
}).send

/**
 * 生成支付订单
 * @orderId int	鉴定订单id
 */
export const jiandingMakeOrder = apiRegister('jiandingMakeOrder', {
    protoId: 1321,
    path: '/xsh/order/jianding/make/'
}).send

/**
 * 个人中心统计
 * @aid int	鉴定师ID
 */
export const jiandingAppraiserInfo = apiRegister('jiandingAppraiserInfo', {
    protoId: 1322,
    path: '/xsh/jianding/my/info/'
}).send


/**
 * 个人中心统计
 * @aid int	鉴定师ID
 */
export const jiandingGetAppraiser = apiRegister('jiandingGetAppraiser', {
    protoId: 1323,
    path: '/xsh/jianding/get/appraiser/'
}).send

/**
 * 获取静态配置
 * @aid int	鉴定师ID
 */
export const jiandingConfig = apiRegister('jiandingConfig', {
    protoId: 1324,
    path: '/xsh/jianding/get/conf/'
}).send

/**
 * 鉴定师提现列表
 * @start int	开始位置 默认0
 * @pageNum int	每页条数 默认10
 */
export const jiandingTake = apiRegister('jiandingTake', {
    protoId: 1327,
    path: '/xsh/jianding/take/list/'
}).send

/**
 * 鉴定师申请提现
 * @money	float	提现金额
 * @bankhome	string	银行
 * @bank	string	开户行
 * @name	string	用户姓名
 * @account	string	账号
 * @remark	string	备注
 * @idCard	string	身份证
 */
export const jiandingTakeMoney = apiRegister('jiandingTakeMoney', {
    protoId: 1329,
    path: '/xsh/jianding/take/money/'
}).send

/**
 * 鉴定师流水列表
 * @page	int	页数 默认1
 * @pageNum	int	每页条数 默认10
 */
export const jiandingMoneyLog = apiRegister('jiandingMoneyLog', {
    protoId: 1329,
    path: '/xsh/jianding/io/list/'
}).send

/**
 * 鉴定师流水列表
 * @orderId		int	订单id 必填
 * @version		int	版本 非必填（默认最新版本）
 */
export const jiandingCert = apiRegister('jiandingCert', {
    protoId: 1345,
    path: '/xsh/jianding/get/cert/'
}).send


